import { state } from '@/store/ota/state';
import { getters } from '@/store/ota/getters';
import { actions } from '@/store/ota/actions';
import { mutations } from '@/store/ota/mutations';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { state, getters, mutations, actions };
